import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function RealestatePage() {
  const pa = usePracticeArea('realestate');
  return <PracticeAreaTemplate pa={pa} />;
}
